let env: { environment };

// for sitemap generation
// let BUILD_ENV = "prod";

if (BUILD_ENV === 'prod') {
  env = require('./environment.prod');
} else {
  env = require('./environment.stage');
}

// @ts-ignore
export const environment = env.environment;
